<template>
  <div style="width: 100%; height: 100%;">
    <iframe style="width: 100%; height: 100%;" src="https://docs.google.com/document/d/e/2PACX-1vQVtnRtDNdSCygAvOfSOwz-ADdXh9cuARoGQFObKpb6zcaptW9farYQcLs3ZSdI4TL_EpjhL60k96nD/pub?embedded=true"></iframe>
  </div>
</template>

<script>
export default {
  name: "BookingPrivacy"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/BookingPrivacy.vue